(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function togglePanel(id, other) {
    var el = document.getElementById(id);
    var hide = document.getElementById(other);
    if (!el) return;
    if (hide) hide.classList.remove('open');
    el.classList.toggle('open');
    if (id === 'searchPanel' && el.classList.contains('open')) {
      var input = el.querySelector('input');
      if (input) input.focus();
    }
  }

  window.auraTogglePanel = togglePanel;

  var menuToggle = $('.menu-toggle');
  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      var nav = document.getElementById('nav');
      if (nav) nav.classList.toggle('open');
    });
  }

  var searchBtn = document.getElementById('searchToggle');
  if (searchBtn) {
    searchBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      togglePanel('searchPanel', 'cartPop');
    });
  }

  var cartBtn = document.getElementById('cartToggle');
  if (cartBtn) {
    cartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      togglePanel('cartPop', 'searchPanel');
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.site-header')) return;
    var s = document.getElementById('searchPanel');
    var c = document.getElementById('cartPop');
    if (s) s.classList.remove('open');
    if (c) c.classList.remove('open');
  });

  function showToast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(window.__toast);
    window.__toast = setTimeout(function () { t.classList.remove('show'); }, 1800);
  }

  function formatMoney(cents, format) {
    var f = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return f.replace(/\{\{\s*amount\s*\}\}/, value)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  function updateCartCount(count) {
    var n = document.getElementById('cartCount');
    if (!n) return;
    n.textContent = count;
    if (count > 0) n.removeAttribute('hidden');
    else n.setAttribute('hidden', '');
  }

  function renderMiniCart(cart) {
    var pop = document.getElementById('cartPop');
    if (!pop) return;
    var empty = document.getElementById('cartEmpty');
    var lines = document.getElementById('cartPopLines');
    var total = document.getElementById('cartPopTotal');
    var actions = document.getElementById('cartPopActions');
    if (!cart || cart.item_count === 0) {
      if (empty) {
        empty.hidden = false;
        empty.textContent = 'Your cart is empty.';
      }
      if (lines) lines.innerHTML = '';
      if (total) total.hidden = true;
      if (actions) actions.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    if (lines) {
      lines.innerHTML = cart.items.map(function (item) {
        var img = (item.image || '').replace(/(\.[a-z]+)(\?|$)/i, '_100x$1$2') || '';
        return '<div class="cart-pop-line">' +
          (img ? '<img src="' + img + '" alt="">' : '<span></span>') +
          '<div><div>' + item.product_title + '</div><div class="meta">' + item.quantity + ' × ' + formatMoney(item.final_line_price / item.quantity) + '</div></div>' +
          '<div>' + formatMoney(item.final_line_price) + '</div></div>';
      }).join('');
    }
    if (total) {
      total.hidden = false;
      total.innerHTML = '<span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span>';
    }
    if (actions) actions.hidden = false;
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        renderMiniCart(cart);
        return cart;
      })
      .catch(function () {});
  }

  window.auraRefreshCart = refreshCart;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.dataset.noAjax === 'true') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function (item) {
        showToast((item.product_title || 'Kit') + ' added to cart');
        return refreshCart();
      })
      .then(function () {
        var pop = document.getElementById('cartPop');
        if (pop) pop.classList.add('open');
      })
      .catch(function (err) {
        showToast((err && err.description) || 'Could not add to cart');
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
      });
  });

  $$('.js-qty').forEach(function (wrap) {
    var input = wrap.querySelector('input[name="quantity"], input.js-qty-input');
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !input) return;
      var d = parseInt(b.getAttribute('data-d'), 10) || 0;
      var min = parseInt(input.min, 10) || 1;
      input.value = Math.max(min, (parseInt(input.value, 10) || min) + d);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  var productForm = document.getElementById('product-form');
  if (productForm) {
    var variantJson = document.getElementById('product-variants-json');
    var variants = [];
    try { variants = variantJson ? JSON.parse(variantJson.textContent) : []; } catch (e) { variants = []; }
    var idInput = productForm.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var optionCount = $$('.chips[data-option-index]').length;

    function selectedOptions() {
      var opts = [];
      $$('.chips[data-option-index]').forEach(function (group) {
        var sel = group.querySelector('.chip.is-selected');
        opts[parseInt(group.getAttribute('data-option-index'), 10)] = sel ? sel.getAttribute('data-value') : '';
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function selectVariant(v) {
      if (!v || !idInput) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      var submit = productForm.querySelector('[type="submit"]');
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? 'Add to cart' : 'Unavailable';
      }
      $$('.js-option-value').forEach(function (el, i) {
        if (v.options[i]) el.textContent = v.options[i];
      });
      if (v.featured_image) {
        var media = document.querySelector('.pdp-media img');
        if (media && v.featured_image.src) media.src = v.featured_image.src;
      }
    }

    document.addEventListener('click', function (e) {
      var chip = e.target.closest('.chip');
      if (!chip || !chip.closest('.pdp-info')) return;
      var group = chip.closest('.chips');
      $$('.chip', group).forEach(function (c) { c.classList.remove('is-selected'); });
      chip.classList.add('is-selected');
      var v = findVariant(selectedOptions());
      selectVariant(v);
    });

    if (optionCount && variants.length) {
      var currentId = idInput ? parseInt(idInput.value, 10) : null;
      var current = variants.find(function (v) { return v.id === currentId; }) || variants.find(function (v) { return v.available; }) || variants[0];
      selectVariant(current);
    }
  }

  function applyCatalogFilter(f) {
    var filters = document.querySelector('.filters');
    if (!filters) return;
    $$('.filter-btn', filters).forEach(function (x) {
      x.classList.toggle('is-active', (x.getAttribute('data-filter') || '') === f);
    });
    $$('#grid .card').forEach(function (c) {
      var cat = (c.getAttribute('data-cat') || '').toLowerCase();
      c.style.display = (f === 'all' || cat.indexOf(f) !== -1) ? '' : 'none';
    });
  }

  var filters = document.querySelector('.filters');
  if (filters) {
    filters.addEventListener('click', function (e) {
      var b = e.target.closest('.filter-btn');
      if (!b || !b.hasAttribute('data-filter')) return;
      var href = b.getAttribute('href') || '';
      var path = href.split('#')[0];
      if (path && path !== location.pathname && path.indexOf('/collections/') !== -1 && path.slice(-4) !== '/all') {
        return;
      }
      e.preventDefault();
      var f = (b.getAttribute('data-filter') || 'all').toLowerCase();
      applyCatalogFilter(f);
      if (history.replaceState) history.replaceState(null, '', f === 'all' ? location.pathname : '#' + f);
    });
    var hash = (location.hash || '').replace('#', '').toLowerCase();
    if (hash) applyCatalogFilter(hash);
  }

  refreshCart();


  var coaJsonEl = document.getElementById('product-coa-json');
  if (coaJsonEl) {
    var coaMap = {};
    try { coaMap = JSON.parse(coaJsonEl.textContent); } catch (e) { coaMap = {}; }
    var purityEl = document.getElementById('pdpPurity');
    var coaBtn = document.getElementById('coaBtn') || document.querySelector('.js-coa-link');
    var listEl = document.getElementById('coaList');
    var noteEl = document.getElementById('coaNote');
    var specPurity = document.querySelector('.specs dd');

    function doseKey(raw) {
      if (!raw) return '';
      return String(raw).replace(/\s*mg$/i, '').trim();
    }

    function applyCoa(raw) {
      var key = doseKey(raw);
      var doses = coaMap.doses || {};
      var entry = doses[key] || doses[key + 'mg'] || doses[raw] || (coaMap.always ? doses['*'] : null);
      var hasAny = Object.keys(doses).length > 0 || (coaMap.list && coaMap.list.length);

      if (coaBtn) {
        if (!hasAny) {
          coaBtn.textContent = 'Batch COA on request';
          coaBtn.href = coaMap.library || '/?view=coa';
          coaBtn.removeAttribute('target');
        } else {
          coaBtn.textContent = 'View COA';
        }
      }

      if (entry) {
        if (purityEl) { purityEl.hidden = false; purityEl.textContent = entry.line; }
        if (coaBtn) { coaBtn.href = entry.href; coaBtn.target = '_blank'; coaBtn.rel = 'noopener'; }
      } else if (hasAny) {
        if (purityEl) {
          purityEl.hidden = false;
          purityEl.innerHTML = (coaMap.fallback || '') + (coaMap.library ? ' <a href="' + coaMap.library + '">Library</a>' : '');
        }
        if (coaBtn) { coaBtn.href = coaMap.library || '/?view=coa'; coaBtn.removeAttribute('target'); }
      } else {
        if (purityEl) { purityEl.hidden = true; purityEl.textContent = ''; }
      }

      if (listEl) {
        var items = coaMap.list || [];
        if (items.length) {
          listEl.hidden = false;
          listEl.innerHTML = items.map(function (c) {
            var client = c.client ? '<span class="coa-client">' + c.client + '</span>' : '';
            return '<li><span>' + c.label + ' · ' + c.extra + '</span>' + client +
              ' <a href="' + c.href + '" target="_blank" rel="noopener">View</a></li>';
          }).join('');
        }
      }
      if (noteEl && coaMap.always && coaMap.fallback) {
        noteEl.hidden = false;
        noteEl.textContent = coaMap.fallback;
      }
    }

    var currentChip = document.querySelector('.pdp-info .chip.is-selected');
    var start = currentChip ? currentChip.getAttribute('data-value') : '';
    applyCoa(start);

    document.addEventListener('click', function (e) {
      var chip = e.target.closest('.pdp-info .chip');
      if (!chip) return;
      applyCoa(chip.getAttribute('data-value'));
    });
  }

})();
